import AdminAxiosInstance from './AdminAxiosInstance'
export const SFTPService = {
  getSFTPs: async () => {
    try {
      const resp = await AdminAxiosInstance.get(`/sftp`)

      return resp
    } catch (error) {
      //console.log(error)
    }
  },

  createSFTP: async (document) => {
    try {
      //console.log(document)
      const resp = await AdminAxiosInstance.post(`/sftp`, document)

      return resp
    } catch (error) {
      //console.log(error)
    }
  },
  deleteSFTP: async (documentId) => {
    try {
      await AdminAxiosInstance.delete(`/sftp/${documentId}`)
      //console.log('delete success')
    } catch (error) {
      //console.log('delete errorr', error)
    }
  },
}
